export type ProductCategory = 'remeras' | 'zapatos' | 'bolsos' | 'accesorios'
export type ProductBadge = 'new' | 'hot' | 'limited'

export interface Product {
  id: number
  name: string
  brand: string
  price: number
  category: ProductCategory
  badge?: ProductBadge
  image: string
}

export const products: Product[] = [
  {
    id: 1,
    name: 'Remera Blade Black',
    brand: 'GUCCI',
    price: 185000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/ukS4ZGZVfDeDvga81Q7AFV/WhatsApp_Image_2026-03-15_at_19.57.45_(3).jpg',
  },
  {
    id: 4,
    name: 'Remera Crystal White',
    brand: 'LOUIS VUITTON',
    price: 320000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/cFixgooYP3WdcKZiURwX2k/WhatsApp_Image_2026-03-15_at_19.57.46.jpg',
  },

  {
    id: 8,
    name: 'Remera Campaign Black',
    brand: 'BALENCIAGA',
    price: 195000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/5UBMc2UFxfKRcDvDuXNQUn/WhatsApp_Image_2026-03-15_at_19.57.45_(2).jpg',
  },

  {
    id: 11,
    name: 'Remera Cross Black',
    brand: 'CHROME HEARTS',
    price: 210000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/kwPzHSrkQnGcm9YHW7XE5j/WhatsApp_Image_2026-03-15_at_19.57.45_(1).jpg',
  },

  {
    id: 16,
    name: 'Remera Graphic White',
    brand: 'HELLSTAR',
    price: 165000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/dDzDp4wnujUTs5ss985uXQ/WhatsApp_Image_2026-03-15_at_19.57.45.jpg',
  },

  {
    id: 20,
    name: 'Remera Paris Embroidered',
    brand: 'LANVIN',
    price: 175000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/6oR9nngLNi2ioxXDjU6AYo/WhatsApp_Image_2026-03-15_at_19.57.46_(2).jpg',
  },

  {
    id: 24,
    name: 'Polo Monogram Black',
    brand: 'LOUIS VUITTON',
    price: 285000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/x8WUBrLibB34EYmvZhPe7z/WhatsApp_Image_2026-03-15_at_19.57.46_(1).jpg',
  },
  {
    id: 25,
    name: 'Mini Flap Black',
    brand: 'TOMMY HILFIGER',
    price: 58000,
    category: 'bolsos',
    image:
      'https://cdn.magicpatterns.com/uploads/55KQ3hsKzCJSvoRwTdGY2f/heylloyd-image-1773625221367.png',
  },

  {
    id: 27,
    name: 'Mini Satchel G Logo',
    brand: 'GUESS',
    price: 145000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/1uQuUPorAkfnhwFSKGnh91/WhatsApp_Image_2026-03-15_at_19.47.38.jpg',
  },
  {
    id: 28,
    name: 'Camera Bag White',
    brand: 'GUESS',
    price: 110000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/2SaeQs9QTNhLxfW9KUJcSj/heylloyd-image-1773623673292.png',
  },
  {
    id: 29,
    name: 'Tote Horseshoe',
    brand: 'TRUE RELIGION',
    price: 98000,
    category: 'bolsos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/v7y3WJXfB22uSo8H5PdhZk/WhatsApp_Image_2026-03-15_at_19.57.00_(9).jpg',
  },
  {
    id: 30,
    name: 'Satchel Navy',
    brand: 'TOMMY HILFIGER',
    price: 105000,
    category: 'bolsos',
    image:
      'https://cdn.magicpatterns.com/uploads/d6uWE9pxEbrqYM3gDGCbiE/heylloyd-image-1773624833883.png',
  },
  {
    id: 31,
    name: 'Flap Bag Tan',
    brand: 'STEVE MADDEN',
    price: 88000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/qDmCQGCFeND2qf8pfJu61f/heylloyd-image-1773624962445.png',
  },
  {
    id: 32,
    name: 'Shoulder Bag Plaid',
    brand: 'TOMMY HILFIGER',
    price: 72000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/9otQx4SyPGwZnhrDaq6BVv/WhatsApp_Image_2026-03-15_at_19.47.38_(2).jpg',
  },
  {
    id: 33,
    name: 'Shoulder Bag G',
    brand: 'GUESS',
    price: 155000,
    category: 'bolsos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/7WRKG4PWAsSBUSGuDovmJF/WhatsApp_Image_2026-03-15_at_19.47.38_(5).jpg',
  },

  {
    id: 37,
    name: 'Top Handle Leopard',
    brand: 'ALDO',
    price: 132000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/wfNFvXAtZg5Ce3n4mtioxM/heylloyd-image-1773626981778.png',
  },
  {
    id: 38,
    name: 'Shoulder Chain Black',
    brand: 'ED HARDY',
    price: 99000,
    category: 'bolsos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/wxio212nDv6oEEhdUoLggD/heylloyd-image-1773627039544.png',
  },
  {
    id: 39,
    name: 'Flap Heart White',
    brand: 'JUICY COUTURE',
    price: 82000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/va8hyMyhmhL27gEHYAYvtB/heylloyd-image-1773627094056.png',
  },
  {
    id: 40,
    name: 'Tote Stripe Blue',
    brand: 'TOMMY HILFIGER',
    price: 115000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/qoa9BaAuUvSivVzjtU3PaH/heylloyd-image-1773626424610.png',
  },
  {
    id: 41,
    name: 'Flap Bag Cream',
    brand: 'STEVE MADDEN',
    price: 92000,
    category: 'bolsos',
    image:
      'https://cdn.magicpatterns.com/uploads/fuo9pczwQKjctTYsccPrRE/heylloyd-image-1773626526320.png',
  },
  {
    id: 42,
    name: 'Barrel Bag Denim',
    brand: 'STEVE MADDEN',
    price: 64000,
    category: 'bolsos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/9CnxgD6u4AG7AnxKXkbjZT/heylloyd-image-1773627224629.png',
  },
  {
    id: 43,
    name: 'Tote LA Quilted',
    brand: 'GUESS',
    price: 168000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/xb3nA2VqigL3FDBK9L3Pph/heylloyd-image-1773626635390.png',
  },
  {
    id: 44,
    name: 'Bucket Bag Cow',
    brand: 'WRANGLER',
    price: 74000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/gnCxeAvBvCgcjefgs1pd4X/heylloyd-image-1773626702433.png',
  },
  {
    id: 45,
    name: 'Shoulder Bag Ivory',
    brand: 'CALVIN KLEIN',
    price: 108000,
    category: 'bolsos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/jWNhuV4hBZnH9YjQ1GqDus/heylloyd-image-1773627173578.png',
  },
  {
    id: 46,
    name: 'Mini Satchel Logo Black',
    brand: 'STEVE MADDEN',
    price: 96000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/xpjuudc5boaDg8WLCggiNp/WhatsApp_Image_2026-03-15_at_19.57.51_(4).jpg',
  },
  {
    id: 47,
    name: 'Top Handle Quilted White',
    brand: 'ALDO',
    price: 105000,
    category: 'bolsos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/gxiTEwAXNreEVapkcQcwWN/WhatsApp_Image_2026-03-15_at_19.57.51.jpg',
  },
  {
    id: 48,
    name: 'Satchel Twist Black',
    brand: 'ALDO',
    price: 118000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/q5Kdngoif7XAQNqN8TXnoz/heylloyd-image-1773627393787.png',
  },
  {
    id: 49,
    name: 'Tote Mini Cream',
    brand: 'ALDO',
    price: 89000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/7RzerckbJVQnudodiC6G59/WhatsApp_Image_2026-03-15_at_19.57.51_(1).jpg',
  },
  {
    id: 50,
    name: 'Tote Monogram Black',
    brand: 'TOMMY HILFIGER',
    price: 125000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/2vjVKY82BJAvNQiGL23bpV/WhatsApp_Image_2026-03-15_at_19.57.51_(2).jpg',
  },
  {
    id: 51,
    name: 'Tote Plaid Red',
    brand: "VICTORIA'S SECRET",
    price: 95000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/1ccdN3deif7hjJSMezxgjG/WhatsApp_Image_2026-03-15_at_19.57.50_(1).jpg',
  },

  {
    id: 53,
    name: 'Hobo Monogram White',
    brand: 'TOMMY HILFIGER',
    price: 98000,
    category: 'bolsos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/3MheHZPmrfV9GHjMsqupWf/WhatsApp_Image_2026-03-15_at_19.59.16_(3).jpg',
  },
  {
    id: 54,
    name: 'Hobo TH Embossed Cream',
    brand: 'TOMMY HILFIGER',
    price: 115000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/cBgZdMV7bFAVm6QnGn6qz8/heylloyd-image-1773630470641.png',
  },
  {
    id: 55,
    name: 'Remera Logo White',
    brand: 'MONCLER',
    price: 245000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/eFbNvHj4zMsSeEmRXjtoun/WhatsApp_Image_2026-03-15_at_19.57.47_(5).jpg',
  },
  {
    id: 56,
    name: 'Remera Lovers Black',
    brand: 'LOUIS VUITTON',
    price: 295000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/ka5ndBEPCH6dWEDfKybuiL/WhatsApp_Image_2026-03-15_at_19.57.47_(4).jpg',
  },
  {
    id: 57,
    name: 'Remera Star Black',
    brand: 'LOUIS VUITTON',
    price: 275000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/qFHEyr24tmjsiBHKcqnBvQ/WhatsApp_Image_2026-03-15_at_19.57.47_(3).jpg',
  },
  {
    id: 58,
    name: 'Remera Logo Classic Black',
    brand: 'GUCCI',
    price: 230000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/u3ht3pt4SVGRM3HrvWRPbY/WhatsApp_Image_2026-03-15_at_19.57.47_(2).jpg',
  },
  {
    id: 59,
    name: 'Remera Monogram Toweling Black',
    brand: 'LOUIS VUITTON',
    price: 310000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/v5KqHzGA23WfZ2W1sPzxrv/WhatsApp_Image_2026-03-15_at_19.57.47_(1).jpg',
  },
  {
    id: 60,
    name: 'Remera Logo White',
    brand: 'AMIRI',
    price: 195000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/1GHs669qd2wnHhHY9AA5Nj/WhatsApp_Image_2026-03-15_at_19.57.48_(3).jpg',
  },
  {
    id: 61,
    name: 'Remera Graphic Art Black',
    brand: 'LOUIS VUITTON',
    price: 340000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/2Uk7nmiNMVdzwMZyVFQL6C/WhatsApp_Image_2026-03-15_at_19.57.48_(2).jpg',
  },
  {
    id: 62,
    name: 'Remera Crystal Star Black',
    brand: 'HELLSTAR',
    price: 175000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/fWcgCwLuCE3EjNcE2eRZgf/WhatsApp_Image_2026-03-15_at_19.57.48_(1).jpg',
  },
  {
    id: 63,
    name: 'Remera Logo Blue',
    brand: 'BALENCIAGA',
    price: 260000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/gwyzQS1jUqQvHQrDytpU86/WhatsApp_Image_2026-03-15_at_19.57.48.jpg',
  },
  {
    id: 64,
    name: 'Remera Classic Black',
    brand: 'BURBERRY',
    price: 220000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/f6urH1WfTwd4qVwVsHiipF/WhatsApp_Image_2026-03-15_at_19.57.49_(11).jpg',
  },
  {
    id: 65,
    name: 'Remera Graffiti Black',
    brand: 'LOUIS VUITTON',
    price: 320000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/mcVEwdFxnVLMZFBkgKUifv/WhatsApp_Image_2026-03-15_at_19.57.49_(10).jpg',
  },
  {
    id: 66,
    name: 'Remera Arch Logo White',
    brand: 'AMIRI',
    price: 185000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/7KkDAMsK5fDU6W1yRv46Cj/WhatsApp_Image_2026-03-15_at_19.57.49_(9).jpg',
  },
  {
    id: 67,
    name: 'Remera Allover Print Black',
    brand: 'BALENCIAGA',
    price: 275000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/9nVJtwnEuugZhXYY5HcRsB/WhatsApp_Image_2026-03-15_at_19.57.49_(8).jpg',
  },
  {
    id: 68,
    name: 'Remera Crystal Logo Pink',
    brand: 'BALENCIAGA',
    price: 290000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/7c8pF4gwcxsCNBGRb5F1oq/WhatsApp_Image_2026-03-15_at_19.57.49_(7).jpg',
  },
  {
    id: 69,
    name: 'Remera Crystal LV White',
    brand: 'LOUIS VUITTON',
    price: 350000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/vBCKshC8AAxkAM23Su4W5P/WhatsApp_Image_2026-03-15_at_19.57.49_(5).jpg',
  },
  {
    id: 70,
    name: 'Remera Multicolor Monogram White',
    brand: 'LOUIS VUITTON',
    price: 330000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/3sjf8DoPYXFp18TCLk4xdj/WhatsApp_Image_2026-03-15_at_19.57.49_(4).jpg',
  },
  {
    id: 71,
    name: 'Remera LVoers Crystal Navy',
    brand: 'LOUIS VUITTON',
    price: 360000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/iyE99guaBLrMSLePc3V5V3/WhatsApp_Image_2026-03-15_at_19.57.49_(3).jpg',
  },
  {
    id: 72,
    name: 'Remera Dragon Logo Black',
    brand: 'MONCLER',
    price: 195000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/hBKKDkFCF79oh5m78WJHbM/WhatsApp_Image_2026-03-15_at_19.57.49_(2).jpg',
  },
  {
    id: 73,
    name: 'Remera Embroidered Logo Black',
    brand: 'ALEXANDER MCQUEEN',
    price: 210000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/pkebDBzzTnY1F91prmXmaY/WhatsApp_Image_2026-03-15_at_19.57.49_(1).jpg',
  },
  {
    id: 74,
    name: 'Remera Purple Sky White',
    brand: 'PURPLE BRAND',
    price: 155000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/mFZ3mFjdF4xEeLWjxHHg7R/WhatsApp_Image_2026-03-15_at_19.57.49_(6).jpg',
  },
  {
    id: 75,
    name: 'Remera Monogram Blue/Black',
    brand: 'LOUIS VUITTON',
    price: 345000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/cTx42oKuQCSQnLmY69ZBm7/WhatsApp_Image_2026-03-15_at_19.57.49.jpg',
  },
  {
    id: 76,
    name: 'Remera LVoers Rainbow Black',
    brand: 'LOUIS VUITTON',
    price: 335000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/vmzVRhRZTi46sneXCjGDQD/WhatsApp_Image_2026-03-15_at_19.57.50_(10).jpg',
  },
  {
    id: 77,
    name: 'Remera Map Print Black',
    brand: 'BALMAIN',
    price: 230000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/hmGWFabykzgeH6vUXo4CFv/WhatsApp_Image_2026-03-15_at_19.57.50_(9).jpg',
  },
  {
    id: 78,
    name: 'Remera Activewear Black',
    brand: 'BALENCIAGA',
    price: 250000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/57SuN9vQfQAJxvFTbG72zw/WhatsApp_Image_2026-03-15_at_19.57.50_(8).jpg',
  },
  {
    id: 79,
    name: 'Remera Flame Logo White',
    brand: 'HELLSTAR',
    price: 165000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/767KLSoU7FshQkvof9AnWJ/WhatsApp_Image_2026-03-15_at_19.57.50_(7).jpg',
  },
  {
    id: 80,
    name: 'Remera Floral Logo White',
    brand: 'ADIDAS',
    price: 45000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/99Bj6x1Fqbwio9XhDRn9JP/WhatsApp_Image_2026-03-15_at_19.57.50_(6).jpg',
  },
  {
    id: 81,
    name: 'Remera Star Graphic Black',
    brand: 'AMIRI',
    price: 190000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/1fpf4KAecVPYdMp7LaQx8w/WhatsApp_Image_2026-03-15_at_19.57.50_(5).jpg',
  },
  {
    id: 82,
    name: 'Remera Dept. Red Logo Black',
    brand: 'GALLERY DEPT.',
    price: 160000,
    category: 'remeras',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/nTYoPniUZiTMVC8rcHrisF/WhatsApp_Image_2026-03-15_at_19.57.50_(4).jpg',
  },
  {
    id: 83,
    name: 'Remera Crystal Surfer Black',
    brand: 'BALENCIAGA',
    price: 310000,
    category: 'remeras',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/9KPs7VfpxbwtUdYrSEycXx/WhatsApp_Image_2026-03-15_at_19.57.50_(3).jpg',
  },
  {
    id: 84,
    name: 'Remera 3B Icon Navy',
    brand: 'BALENCIAGA',
    price: 245000,
    category: 'remeras',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/kjRqaMjvsSacGDnSGzc78Y/WhatsApp_Image_2026-03-15_at_19.57.50_(2).jpg',
  },

  {
    id: 86,
    name: 'Zapatillas Classic White',
    brand: 'CALVIN KLEIN',
    price: 120000,
    category: 'zapatos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/9gP9wKP9mLb8qVTGbWrUBd/WhatsApp_Image_2026-03-15_at_19.57.02.jpg',
  },
  {
    id: 87,
    name: 'Zapatillas Classic White/Navy',
    brand: 'TOMMY HILFIGER',
    price: 95000,
    category: 'zapatos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/dCj2iH75a8r3ffNqCmZzYz/WhatsApp_Image_2026-03-15_at_19.59.16.jpg',
  },
  {
    id: 88,
    name: 'Zapatillas Retro Beige/White',
    brand: 'CALVIN KLEIN',
    price: 130000,
    category: 'zapatos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/2LZG9cu53xkwLbe2SZK11Q/WhatsApp_Image_2026-03-15_at_19.59.17_(3).jpg',
  },
  {
    id: 89,
    name: 'Billetera Monogram Grey',
    brand: 'GUESS',
    price: 75000,
    category: 'accesorios',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/2pypkg8Ua3yYq5fDTaQ6WX/WhatsApp_Image_2026-03-15_at_19.47.40_(2).jpg',
  },
  {
    id: 90,
    name: 'Lip Gloss Set Heart Box',
    brand: 'PARIS HILTON',
    price: 45000,
    category: 'accesorios',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/oQcLCE1LXot9L4Jhswhcks/WhatsApp_Image_2026-03-15_at_19.56.01_(4).jpg',
  },
  {
    id: 91,
    name: 'Mascara Duo High Rise',
    brand: 'LOFTY LASHES',
    price: 25000,
    category: 'accesorios',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/rrxCXESMzHYFJ3U6bDWUnX/WhatsApp_Image_2026-03-15_at_19.56.01_(3).jpg',
  },
  {
    id: 92,
    name: 'Kit Makeup Collection',
    brand: 'NYX',
    price: 55000,
    category: 'accesorios',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/4LJYtHbbmPgVBMvskjaJG3/WhatsApp_Image_2026-03-15_at_19.56.02_(1).jpg',
  },
  {
    id: 93,
    name: 'Pantuflas Fur Crystal Pink',
    brand: 'JUICY COUTURE',
    price: 70000,
    category: 'zapatos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/pYSpS2yh1b6zeAH7ohwGh2/WhatsApp_Image_2026-03-15_at_19.57.44_(1).jpg',
  },
  {
    id: 94,
    name: 'Pantuflas Crystal Fur Pink',
    brand: 'BEBE',
    price: 65000,
    category: 'zapatos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/gsuKLScBGayat5nNz3LPcR/WhatsApp_Image_2026-03-15_at_19.57.44.jpg',
  },
  {
    id: 95,
    name: 'Pantuflas Fur Logo White',
    brand: 'JUICY COUTURE',
    price: 75000,
    category: 'zapatos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/4k8LTyyYLCbRfryVX4ogy2/WhatsApp_Image_2026-03-15_at_19.59.15_(2).jpg',
  },
  {
    id: 96,
    name: 'Pantuflas Crystal Fur Black',
    brand: 'BEBE',
    price: 65000,
    category: 'zapatos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/55HouqKeJ3EB3i3GupxLuC/WhatsApp_Image_2026-03-15_at_19.59.15_(1).jpg',
  },
  {
    id: 97,
    name: 'Slides MK Monogram Navy',
    brand: 'MICHAEL KORS',
    price: 85000,
    category: 'zapatos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/stFzmfQZJtfg9RMcTP6hbx/WhatsApp_Image_2026-03-15_at_19.59.16_(2).jpg',
  },
  {
    id: 98,
    name: 'Flip Flops Floral Navy',
    brand: 'TOMMY HILFIGER',
    price: 45000,
    category: 'zapatos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/92rGrNhsYVGVSFmcMzU74W/WhatsApp_Image_2026-03-15_at_19.57.44_(2)_-_copia.jpg',
  },
  {
    id: 99,
    name: 'Pantuflas Fur Logo Black',
    brand: "VICTORIA'S SECRET",
    price: 68000,
    category: 'zapatos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/dMog2aTYt94ws3xJh2JxHr/WhatsApp_Image_2026-03-15_at_19.59.14_(1).jpg',
  },
  {
    id: 100,
    name: 'Flip Flops Polka Dots',
    brand: 'TOMMY HILFIGER',
    price: 45000,
    category: 'zapatos',
    image:
      'https://cdn.magicpatterns.com/uploads/2xq3uWs3XEQXHvDbSrN2kC/WhatsApp_Image_2026-03-15_at_19.59.18_(1).jpg',
  },
  {
    id: 101,
    name: 'Zapatillas Snoopy White',
    brand: 'PEANUTS',
    price: 95000,
    category: 'zapatos',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/cSJx8ZjNeuQ6UhMgaAJ6ru/WhatsApp_Image_2026-03-15_at_19.47.39_(3).jpg',
  },
  {
    id: 102,
    name: 'The Acne Set',
    brand: 'THE ORDINARY',
    price: 55000,
    category: 'accesorios',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/uR6rfFqgffheboXYVe1d4q/WhatsApp_Image_2026-03-15_at_19.56.01_(2).jpg',
  },
  {
    id: 103,
    name: 'Duck Plump Lip Gloss',
    brand: 'NYX',
    price: 18000,
    category: 'accesorios',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/8bA9ekY9ZEsecq2Wnhpkfb/WhatsApp_Image_2026-03-15_at_19.56.01_(1).jpg',
  },
  {
    id: 104,
    name: 'Hand Cream Trio Japan',
    brand: 'WANDERFLOWER',
    price: 38000,
    category: 'accesorios',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/f1EtuQX3ZfxzWToKT1jerm/WhatsApp_Image_2026-03-15_at_19.56.01.jpg',
  },
  {
    id: 105,
    name: 'My Orchard Hand Cream Set',
    brand: 'FRUDIA',
    price: 35000,
    category: 'accesorios',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/xiNRCUDjdd2gLyP8KXF6MZ/WhatsApp_Image_2026-03-15_at_19.56.02_(3).jpg',
  },
  {
    id: 106,
    name: 'Lip Butter Balm Set',
    brand: 'ED HARDY',
    price: 42000,
    category: 'accesorios',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/fDhhd211JHCuDA2i6DVpZg/WhatsApp_Image_2026-03-15_at_19.56.02_(2).jpg',
  },
  {
    id: 107,
    name: 'Billetera Logo Black',
    brand: 'NAUTICA',
    price: 45000,
    category: 'bolsos',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/eo1WAhbbNS7cSYdgADRwwq/WhatsApp_Image_2026-03-15_at_19.56.03_(2).jpg',
  },
  {
    id: 108,
    name: 'Lentes Tortoise Cat Eye',
    brand: 'JESSICA SIMPSON',
    price: 55000,
    category: 'accesorios',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/9TijWs1HjNMLzGqXKkhvmz/WhatsApp_Image_2026-03-15_at_19.56.59_(1).jpg',
  },
  {
    id: 109,
    name: 'Tumbler Floral B&W',
    brand: 'STUDIO',
    price: 32000,
    category: 'accesorios',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/6LzAuR2t31f5LFvYiThLLf/WhatsApp_Image_2026-03-15_at_19.56.59.jpg',
  },
  {
    id: 110,
    name: 'Hand Cream Trio Japan',
    brand: 'WANDERFLOWER',
    price: 38000,
    category: 'accesorios',
    image:
      'https://cdn.magicpatterns.com/uploads/qxvFxaWoE9ZdAews9GN8Mk/WhatsApp_Image_2026-03-15_at_19.57.00_(10).jpg',
  },
  {
    id: 111,
    name: 'Manicure Set Suitcase',
    brand: 'MARIE CLAIRE',
    price: 28000,
    category: 'accesorios',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/1X2UH14aYEVScPYQTByefc/WhatsApp_Image_2026-03-15_at_19.57.00_(8).jpg',
  },
  {
    id: 112,
    name: 'Hyaluronic Acid 2% + B5',
    brand: 'THE ORDINARY',
    price: 22000,
    category: 'accesorios',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/u8RFAX6xNNATQYf7h691NW/WhatsApp_Image_2026-03-15_at_19.57.00_(7).jpg',
  },
  {
    id: 113,
    name: 'Collar Silver Plated Sun',
    brand: 'MIA SAVINE',
    price: 35000,
    category: 'accesorios',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/9m3W4JAaaXeAKnY2M43HJr/WhatsApp_Image_2026-03-15_at_19.57.00_(6).jpg',
  },
  {
    id: 114,
    name: 'Pañuelo Floral Polka Dots',
    brand: 'STUDIO',
    price: 28000,
    category: 'accesorios',
    badge: 'new',
    image:
      'https://cdn.magicpatterns.com/uploads/1XzvcvfvSyyDZ1bBnyqGXY/WhatsApp_Image_2026-03-15_at_19.57.00_(5).jpg',
  },
  {
    id: 115,
    name: 'PDRN Hyaluronic Acid 100 Cream',
    brand: 'ANUA',
    price: 42000,
    category: 'accesorios',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/uTf4F7GaSZVy8m6xqVkFBt/WhatsApp_Image_2026-03-15_at_19.57.00_(4).jpg',
  },
  {
    id: 116,
    name: 'Lash Glam Mascara Set',
    brand: 'BEAUTY EVOLVED',
    price: 30000,
    category: 'accesorios',
    badge: 'limited',
    image:
      'https://cdn.magicpatterns.com/uploads/qct4LrqGAUtEfvy9TEHuDz/WhatsApp_Image_2026-03-15_at_19.57.00_(2).jpg',
  },
  {
    id: 117,
    name: 'Tote Bag Logo B&W',
    brand: 'STEVE MADDEN',
    price: 85000,
    category: 'bolsos',
    badge: 'hot',
    image:
      'https://cdn.magicpatterns.com/uploads/5Wann7wCK9nNu2V4UVacLm/heylloyd-image-1773626881221.png',
  },
]

export const categories = [
  { key: 'todos' as const, label: 'Todos' },
  { key: 'bolsos' as const, label: 'Bolsos' },
  { key: 'accesorios' as const, label: 'Accesorios' },
  { key: 'zapatos' as const, label: 'Zapatillas y Pantuflas' },
  { key: 'remeras' as const, label: 'Remeras' },
] as const

export type CategoryFilter = 'todos' | ProductCategory
